const wholesaleService = {
  submitInquiry: async (formData) => {
    try {
      console.log('Wholesale inquiry:', formData);
      await new Promise(resolve => setTimeout(resolve, 1000));
      return {
        success: true,
        message: 'Thank you for your wholesale inquiry! We will respond within 24-48 hours.'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Failed to submit inquiry. Please try again.'
      };
    }
  },

  getWholesaleInfo: () => ({
    minimumOrders: {
      muruku: '30-50 units',
      peanuts: '80-100 units', 
      sweets: '25-30 units'
    },
    discounts: [
      '20% off retail prices for MOQ orders',
      'Additional 5% for orders above S$500',
      'Custom pricing for regular customers'
    ],
    contact: {
      name: 'Priya Sharma',
      title: 'Wholesale Manager',
      phone: '+65 9123 4567',
      email: 'wholesale@spicesnacks.sg'
    }
  })
};

export default wholesaleService;